import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import ActivityTemplateFactory from "../../Entity/Factories/ActivityTemplateFactory";
import { ActivityTemplateInterface } from "../../Entity/Entities/Activity/ActivityTemplateInterface";

class ActivityTemplateUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const activityTemplate: ActivityTemplateInterface = ActivityTemplateFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_SUCCESS,
      payload: {
        activityTemplate: activityTemplate
      }
    });
  }

}

export { ActivityTemplateUpdate };
